function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "3.061617e-15%",
  id: "a"
}, React.createElement("stop", {
  stopColor: "#C8C8C8",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#979797",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-1066.000000, -281.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(795.000000, 222.000000)"
}, React.createElement("g", {
  transform: "translate(261.000000, 59.000000)"
}, React.createElement("g", {
  transform: "translate(10.000000, 0.000000)"
}, React.createElement("g", null, React.createElement("circle", {
  fill: "url(#a)",
  opacity: 0.5,
  cx: 20,
  cy: 20,
  r: 20
}), React.createElement("path", {
  d: "M12.1212121,21.5 C11.292785,21.5 10.6212121,20.8284271 10.6212121,20 C10.6212121,19.1715729 11.292785,18.5 12.1212121,18.5 L27.8787879,18.5 C28.707215,18.5 29.3787879,19.1715729 29.3787879,20 C29.3787879,20.8284271 28.707215,21.5 27.8787879,21.5 L12.1212121,21.5 Z",
  fill: "#FFFFFF"
})))))));

const SvgNotDoneDeselectedIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "40px",
  height: "40px",
  viewBox: "0 0 40 40",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgNotDoneDeselectedIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/not-done-deselected-icon.03ccdc1a.svg";
export { ForwardRef as ReactComponent };